/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SeasonPassStatus } from './SeasonPassStatus';
import {
    SeasonPassStatusFromJSON,
    SeasonPassStatusFromJSONTyped,
    SeasonPassStatusToJSON,
    SeasonPassStatusToJSONTyped,
} from './SeasonPassStatus';
import type { SeasonScopeType } from './SeasonScopeType';
import {
    SeasonScopeTypeFromJSON,
    SeasonScopeTypeFromJSONTyped,
    SeasonScopeTypeToJSON,
    SeasonScopeTypeToJSONTyped,
} from './SeasonScopeType';
import type { SeasonTier } from './SeasonTier';
import {
    SeasonTierFromJSON,
    SeasonTierFromJSONTyped,
    SeasonTierToJSON,
    SeasonTierToJSONTyped,
} from './SeasonTier';
import type { SeasonProgressionRule } from './SeasonProgressionRule';
import {
    SeasonProgressionRuleFromJSON,
    SeasonProgressionRuleFromJSONTyped,
    SeasonProgressionRuleToJSON,
    SeasonProgressionRuleToJSONTyped,
} from './SeasonProgressionRule';

/**
 * 
 * @export
 * @interface SeasonPassResponse
 */
export interface SeasonPassResponse {
    /**
     * 
     * @type {string}
     * @memberof SeasonPassResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SeasonPassResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SeasonPassResponse
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof SeasonPassResponse
     */
    imageAssetId?: string;
    /**
     * 
     * @type {SeasonScopeType}
     * @memberof SeasonPassResponse
     */
    scopeType: SeasonScopeType;
    /**
     * 
     * @type {string}
     * @memberof SeasonPassResponse
     */
    scopeId?: string;
    /**
     * 
     * @type {string}
     * @memberof SeasonPassResponse
     */
    sponsorBrandId?: string;
    /**
     * 
     * @type {number}
     * @memberof SeasonPassResponse
     */
    startDate: number;
    /**
     * 
     * @type {number}
     * @memberof SeasonPassResponse
     */
    endDate: number;
    /**
     * 
     * @type {SeasonPassStatus}
     * @memberof SeasonPassResponse
     */
    status: SeasonPassStatus;
    /**
     * 
     * @type {Array<SeasonProgressionRule>}
     * @memberof SeasonPassResponse
     */
    progressionRules: Array<SeasonProgressionRule>;
    /**
     * 
     * @type {Array<SeasonTier>}
     * @memberof SeasonPassResponse
     */
    tiers: Array<SeasonTier>;
    /**
     * 
     * @type {string}
     * @memberof SeasonPassResponse
     */
    leaderboardCompetitionId?: string;
    /**
     * Resolved CDN URL for the sponsor brand's logo asset. Injected at API response time — not stored in the model.
     * @type {string}
     * @memberof SeasonPassResponse
     */
    sponsorLogoUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof SeasonPassResponse
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof SeasonPassResponse
     */
    updatedAt: number;
}



/**
 * Check if a given object implements the SeasonPassResponse interface.
 */
export function instanceOfSeasonPassResponse(value: object): value is SeasonPassResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('scopeType' in value) || value['scopeType'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('progressionRules' in value) || value['progressionRules'] === undefined) return false;
    if (!('tiers' in value) || value['tiers'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function SeasonPassResponseFromJSON(json: any): SeasonPassResponse {
    return SeasonPassResponseFromJSONTyped(json, false);
}

export function SeasonPassResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeasonPassResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'imageAssetId': json['imageAssetId'] == null ? undefined : json['imageAssetId'],
        'scopeType': SeasonScopeTypeFromJSON(json['scopeType']),
        'scopeId': json['scopeId'] == null ? undefined : json['scopeId'],
        'sponsorBrandId': json['sponsorBrandId'] == null ? undefined : json['sponsorBrandId'],
        'startDate': json['startDate'],
        'endDate': json['endDate'],
        'status': SeasonPassStatusFromJSON(json['status']),
        'progressionRules': ((json['progressionRules'] as Array<any>).map(SeasonProgressionRuleFromJSON)),
        'tiers': ((json['tiers'] as Array<any>).map(SeasonTierFromJSON)),
        'leaderboardCompetitionId': json['leaderboardCompetitionId'] == null ? undefined : json['leaderboardCompetitionId'],
        'sponsorLogoUrl': json['sponsorLogoUrl'] == null ? undefined : json['sponsorLogoUrl'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function SeasonPassResponseToJSON(json: any): SeasonPassResponse {
    return SeasonPassResponseToJSONTyped(json, false);
}

export function SeasonPassResponseToJSONTyped(value?: SeasonPassResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'imageAssetId': value['imageAssetId'],
        'scopeType': SeasonScopeTypeToJSON(value['scopeType']),
        'scopeId': value['scopeId'],
        'sponsorBrandId': value['sponsorBrandId'],
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'status': SeasonPassStatusToJSON(value['status']),
        'progressionRules': ((value['progressionRules'] as Array<any>).map(SeasonProgressionRuleToJSON)),
        'tiers': ((value['tiers'] as Array<any>).map(SeasonTierToJSON)),
        'leaderboardCompetitionId': value['leaderboardCompetitionId'],
        'sponsorLogoUrl': value['sponsorLogoUrl'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

